import React from 'react';
import { withPrefix } from 'gatsby';
import { Link } from 'gatsby';
import { animated } from 'react-spring';

const LogoImages = ({ logoOpacity }) => (
  <>
    <img
      css={{
        height: 37,
        zIndex: 2,
        opacity: 1,
        position: 'relative',
      }}
      src={withPrefix('/logo-le-reacteur.png')}
      alt="Le Reacteur - Logo"
    />

    <animated.img
      css={{
        height: 37,
        zIndex: 3,
        left: 0,
        position: 'absolute',
      }}
      style={{ opacity: logoOpacity }}
      src={withPrefix('/logo-le-reacteur-2.png')}
      alt="Le Reacteur - Logo"
    />
  </>
);

const Logo = ({ logoOpacity, minimal }) =>
  minimal ? (
    <div css={{ position: 'relative' }}>
      <LogoImages logoOpacity={logoOpacity} />
    </div>
  ) : (
    <Link css={{ position: 'relative' }} to="/">
      <LogoImages logoOpacity={logoOpacity} />
    </Link>
  );

export default Logo;
